import type { CompanionBaseRecord } from "./bases";
import { eventSlug, parseLocalEventQuery } from "./local-events";
import { UUID } from "./outings";

export type DiscoveryStay = Pick<CompanionBaseRecord, "id" | "anchorSlug" | "startsOn" | "endsOn">;

/** A navigation hint, never authority to read a private stay or invite anyone. */
export function companionEventsHref(stay: DiscoveryStay | null | undefined, view: "today" | "tonight" | "week" | "stay" = "stay"): string {
  if (!stay || !eventSlug(stay.anchorSlug)) return `/companion/explore/events?view=${view === "stay" ? "week" : view}`;
  const params = new URLSearchParams({ place: stay.anchorSlug, view });
  if (view === "stay") {
    params.set("start", stay.startsOn ?? ""); params.set("end", stay.endsOn ?? "");
    if (!parseLocalEventQuery(params)) {
      params.set("view", "week"); params.delete("start"); params.delete("end");
    }
  }
  if (UUID.test(stay.id)) params.set("stay", stay.id);
  return `/companion/explore/events?${params}`;
}

/** Company is an explicit entry intent only. The saved outing remains private. */
export function companionCompanyHref(baseId?: string | null): string {
  const params = new URLSearchParams({ company: "1" });
  if (baseId && UUID.test(baseId)) params.set("base", baseId);
  return `/companion/plan/new?${params}`;
}
